module.exports = __webpack_public_path__ + "img/collection_fish.efd4718a.png";